import { PLATFORM_PARAMETER } from "../../../constants";
import getPartnerId from "./getPartnerId";

const buildParamsFromWebContext = (webContext, production) => {
  const { browseCountry, browseCurrency, platform } = webContext;

  const criteoPartnerId = getPartnerId(browseCountry, production);
  const environment = PLATFORM_PARAMETER[platform];
  const currency = browseCurrency;

  return {
    criteoPartnerId,
    currency,
    environment
  };
};

export default buildParamsFromWebContext;
